import React from 'react';
import style from './app-box.module.scss';
import type { AppBoxSkin } from './app-box.types';

import { NarrowAppBoxSkeleton } from './app-box-layouts/narrow-app-box';
import { RegularAppBoxSkeleton } from './app-box-layouts/regular-app-box';
import { WideAppBoxSkeleton } from './app-box-layouts/wide-app-box';
import { SlimAppBoxSkeleton } from './slim-app-box-skeleton';

export interface AppBoxSkeletonProps {
  skin?: AppBoxSkin;
}

export function AppBoxSkeleton({ skin = 'default' }: AppBoxSkeletonProps) {
  return (
    <div
      className={`${style.appBoxSkeleton} ${
        skin === 'slim' ? style.skinSlim : style.skinDefault
      }`}
    >
      {skin === 'slim' ? (
        <>
          <SlimAppBoxSkeleton className={style.slimLayout} />
        </>
      ) : (
        <>
          <NarrowAppBoxSkeleton className={style.narrowLayout} />
          <RegularAppBoxSkeleton className={style.regularLayout} />
          <WideAppBoxSkeleton className={style.wideLayout} />
        </>
      )}
    </div>
  );
}
